var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 713.155,
    height: 713.154,
    viewBox: "0 0 713.155 713.154",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.158,
    y1: 0.395,
    x2: 1.023,
    y2: 0.777,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f3040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07111a"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_62661",
    x: 0,
    y: 0,
    width: 713.155,
    height: 713.154,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 30,
    dy: -30,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000910",
    floodOpacity: 0.239
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_62661)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62661-2",
    "data-name": "Path 62661",
    d: "M59.13,325.246a1.206,1.206,0,0,0-.812-.705L0,309.435V230.262l58.317-15.105a1.207,1.207,0,0,0,.812-.706l22.546-54.43a1.206,1.206,0,0,0-.076-1.073L51.045,107.028l55.983-55.983L158.946,81.6a1.208,1.208,0,0,0,1.074.075L214.45,59.13a1.205,1.205,0,0,0,.705-.812L230.262,0h79.173L324.54,58.318a1.207,1.207,0,0,0,.706.812l54.43,22.546a1.206,1.206,0,0,0,1.073-.075l51.919-30.556,55.983,55.983L458.1,158.947a1.2,1.2,0,0,0-.075,1.073l22.546,54.43a1.207,1.207,0,0,0,.812.706L539.7,230.262v79.172l-58.318,15.106a1.206,1.206,0,0,0-.812.705l-22.546,54.43a1.207,1.207,0,0,0,.075,1.074l30.556,51.918-55.983,55.984L380.75,458.1a1.206,1.206,0,0,0-1.073-.075l-54.43,22.545a1.21,1.21,0,0,0-.707.812L309.435,539.7H230.262l-15.106-58.319a1.208,1.208,0,0,0-.705-.812L160.02,458.022a1.208,1.208,0,0,0-1.074.075l-51.918,30.556L51.045,432.669,81.6,380.751a1.208,1.208,0,0,0,.076-1.074Zm115.313,40.008a134.925,134.925,0,1,0,0-190.812,134.925,134.925,0,0,0,0,190.812",
    transform: "matrix(0.1, -0.99, 0.99, 0.1, 30, 626.74)",
    fill: "url(#linear-gradient)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCog);
export default __webpack_public_path__ + "static/media/cog.f86553fbadc3b4a3d2e2f2a629bf3b5b.svg";
export { ForwardRef as ReactComponent };